// extracted by mini-css-extract-plugin
export var carousel = "review-list-module--carousel--PDNIj";
export var wrapper = "review-list-module--wrapper--10hbW";